import { ApiData } from "../InvestmentSimulator/types"
import dataInvestors from "./dataInvestors.json"

export interface TabData {
  subtitle?: string
  text?: string
  button?: any
  buttonsText?: any[]
  rulerTitle?: string
  rulerText?: string
  title?: string
  itemsList?: any[]
  image?: any
  appTitle?: string
  appStoreLink?: any
  appStoreLogo?: any
  googlePlayLink?: any
  googlePlayLogo?: any
  blockToRender: string
}

export interface InvestmentData {
  isFetched: boolean
  investmentData?: ApiData
  isProduction?: boolean
}

export const transformTabData = (tabs: any[]): TabData[] => {
  return tabs.map((tab) => ({
    ...tab?.["0"],
    blockToRender: tab?.blockToRender,
  }))
}

export const getInvestmentData = async (
  fetchFunction: () => Promise<ApiData>,
  environment?: string,
): Promise<InvestmentData> => {
  const isProduction = environment === "production"
  let investmentData: InvestmentData = {
    investmentData: undefined,
    isFetched: false,
    isProduction,
  }

  try {
    investmentData.investmentData = await fetchFunction()
    investmentData.isFetched = true
  } catch (error) {
    console.error("Failed to load investment data:", error)
    // Only use mock data in staging, not in production
    if (!isProduction) {
      investmentData.investmentData = dataInvestors
      investmentData.isFetched = false
    }
  }

  return investmentData
}
